





















































































































import { Component, Vue } from "vue-property-decorator";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { gruposList } from "@/models/administracao/usuario/GrupoModel";
import {
  CadastroUsuarioModel,
  USUARIO_DEFAULT,
} from "@/models/administracao/usuario/CadastroUsuarioModel";
import { cadastroUsuarioService } from "@/service/cadastro/administrativo/usuario/CadastroUsuarioService";
import { RetornoMensagemDTO } from "@/api/cadastro/saude/RetornoMensagemDTO";

@Component({
  components: {
    GsModalDialog,
  },
})
export default class CadastroUsuarioAdministrativo extends Vue {
  isAteracao = false;

  cadastroUsuario: CadastroUsuarioModel = USUARIO_DEFAULT();
  // modalMensagemSalvar = false;
  // mensagemErro = false;
  // textoMensagemSalvar = "";

  dialogType = "";
  showDialog = false;
  dialogTitle = "";
  dialogMessage = "";

  get grupos() {
    return gruposList;
  }

  mounted() {
    this.isAteracao = !!this.$route.params.idUsuario;
    if (!!this.$route.params.idUsuario) {
      cadastroUsuarioService
        .obterusuario(Number(this.$route.params.idUsuario))
        .then((cadastroModel: CadastroUsuarioModel) => {
          this.cadastroUsuario = cadastroModel;
        });
    }
  }

  cancelar() {
    this.$router.push({ name: "ListagemUsuarios" });
  }

  salvar() {
    cadastroUsuarioService
      .salvarUsuario(this.cadastroUsuario)
      .then((response: RetornoMensagemDTO) => {
        this.openDialog('success', 'Sucesso', response.mensagem);
      })
      .catch((error: Error) => {
        console.log(error);
        this.openDialog('error', 'Erro', error.message);
      })
      .finally(() => {});
  }

  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    if (this.dialogType == 'success') {
      this.$router.push({ name: "ListagemUsuarios" });
    }
    this.showDialog = false;
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      case "confirm":
        color = "error";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }
}
